import React, { useState } from "react";
import {
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    MenuItem,
    InputLabel,
    Select,
    Grid,
    Typography,
    IconButton,
} from "@mui/material";
import { List, ListItem, ListItemText } from '@mui/material';
import { CloseOutlined } from "@mui/icons-material";
import { DatePicker, DateTimePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";


function FilterAllCampaignsModel({
    open,
    searchParams,
    setSearchParams,
    handleClickOpenModel,
    handleCloseFilterModel,
    handleClickSearch,
}) {
    const [search, setSearch] = useState(searchParams);
    const [selectedDate, setSelectedDate] = useState(null);

    const handleDateChangeCreatedAt = (date) => {
        setSearchParams({ ...searchParams, "createdAt": date });

    };
    const handleDateChangeExecutedTime = (date) => {
        setSearchParams({ ...searchParams, "executedTime": date });

    };

    const [dates, setDates] = useState([
        '2024-05-01',
        '2024-05-05',
        '2024-05-10',
        '2024-05-15',
        '2024-05-20',
    ]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');


    const handleStartDateChange = (event) => {
        setStartDate(event.target.value);
    };

    const handleEndDateChange = (event) => {
        setEndDate(event.target.value);
    };



    const handleChange = (e) => {
        const value = e.target.value;
        const name = e.target.name;
        setSearch({ ...search, [name]: value });
    };
    const campaignStatus = [
        "created",
        "pending",
        "validation_failed",
        "executed",
        "execution_failed",
        "running",
        "scheduled",
        "scheduled_cancel"
    ];

    const onClickClear = () => {



        setSearchParams({
            botName: "",
            campaignName: "",
            clientName: "",
            templateName: "",
            status: "",
            // createdAt: null,
            // executedTime: null,
            createdAtStartDate: "",
            createdAtEndDate: "",
            executedAtStartDate: "",
            executedAtEndDate: "",
        });

        handleClickSearch({
            botName: "",
            campaignName: "",
            clientName: "",
            templateName: "",
            createdAtStartDate: "",
            createdAtEndDate: "",
            executedAtStartDate: "",
            executedAtEndDate: "",
            status: "",
        })
    };
    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={handleCloseFilterModel}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <Typography variant="h5"> Campaign List Filter</Typography>
                    <IconButton onClick={() => handleCloseFilterModel()}>
                        <CloseOutlined />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent
                    sx={{
                        overflowY: "hidden",
                        display: "flex",
                        flexDirection: "column",
                        gap: "30px",
                        width: "500px",
                    }}
                >
                    <Grid container fullWidth justifyContent={"space-between"}>
                        <Grid item md={5.5}>
                            <TextField
                                value={search.campaignName}
                                name="campaignName"
                                onChange={handleChange}
                                label="Campaign Name"
                                fullWidth
                                placeholder=" Enter Campaign Name"
                            />
                        </Grid>
                        <Grid item md={5.5}>
                            <TextField
                                value={search.botName}
                                name="botName"
                                onChange={handleChange}
                                label="Bot Name"
                                fullWidth
                                placeholder=" Enter Bot Name"
                            />
                        </Grid>
                    </Grid>
                    <Grid container fullWidth justifyContent={"space-between"}>
                        <Grid item md={5.5}>
                            <TextField
                                value={search.templateName}
                                name="templateName"
                                onChange={handleChange}
                                label="Template Name"
                                fullWidth
                                placeholder="Enter template name"
                            />
                        </Grid>
                        <Grid item md={5.5}>

                            <FormControl fullWidth>
                                <InputLabel id="demo-controlled-open-select-label">
                                    Status
                                </InputLabel>
                                <Select
                                    labelId="demo-controlled-open-select-label"
                                    id="demo-controlled-open-select"
                                    name="status"
                                    value={search.status}
                                    label="Status"
                                    onChange={handleChange}
                                >
                                    {campaignStatus.map((status) => (
                                        <MenuItem value={status}>
                                            {status.replace("_", " ").toLocaleUpperCase()}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                        </Grid>
                    </Grid>

                    <Grid container fullWidth justifyContent={"space-between"}>
                        <Grid item md={5.5}>
                            <TextField
                                fullWidth
                                type="date"
                                label="Created Date"
                                name="createdAtStartDate"
                                value={search.createdAtStartDate}
                                onChange={handleChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />

                        </Grid>
                        {/* <Grid item md={5.5}>
                            <TextField
                                fullWidth
                                type="date"
                                label="Created End Date"
                                name="createdAtEndDate"
                                value={search.createdAtEndDate}
                                onChange={handleChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />

                        </Grid>
                    </Grid>

                    <Grid container fullWidth justifyContent={"space-between"}> */}
                        <Grid item md={5.5}>
                            <TextField
                                fullWidth
                                type="date"
                                label="Executed Date"
                                name="executedAtStartDate"
                                value={search.executedAtStartDate}
                                onChange={handleChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />

                        </Grid>
                        {/* <Grid item md={5.5}>
                            <TextField
                                fullWidth
                                type="date"
                                label="Executed End Date"
                                name="executedAtEndDate"
                                value={search.executedAtEndDate}
                                onChange={handleChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />

                        </Grid> */}
                    </Grid>
                    <Grid container fullWidth justifyContent={"space-between"}>

                    </Grid>
                </DialogContent>

                <DialogActions
                    style={{
                        padding: "1rem 1.5rem",
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: ".25rem",
                    }}
                >
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => onClickClear()}
                    >
                        Clear
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleClickSearch(search)}
                        autoFocus
                    >
                        Search{" "}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export default FilterAllCampaignsModel;
